import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'componentsV2/Hero/components/Overlay';
import Favorite from 'componentsV2/Favorite';
import { useSelector } from 'react-redux';
import PersonalityName from '../../components/PersonalityName';
import Avatar from '../../components/Avatar';
import { PersonalityProcessor } from '../../processors';
import style from './PersonalityView.module.scss';

const Personality = ({ item, manager }) => {
  const { favoritableItems } = useSelector(state => state.personality);
  const { logoProps, title } = PersonalityProcessor({
    panel: item,
    item,
  });

  return (
    <>
      <Overlay theme={style}>
        <Avatar theme={style} {...logoProps} />
        <PersonalityName theme={style} text={title} />
        <Favorite item={item} manager={manager} favoritableItems={favoritableItems} />
      </Overlay>
    </>
  );
};

Personality.propTypes = {
  item: PropTypes.shape({}),
  manager: PropTypes.shape({}),
};

export default Personality;
